import PropTypes from 'prop-types';
import React from 'react'

import { TextLength } from '~/components'
import { TextLoader } from '~/components/Loaders'


export default class extends React.Component {
    static propTypes = {
		user: PropTypes.object.isRequired,
		editing_fields: PropTypes.bool.isRequired,
		updateName: PropTypes.func.isRequired,
	};

    static contextTypes = {
		store: PropTypes.object.isRequired
	};

    render() {

		let { user, editing_fields, updateName } = this.props,
			fetchingUser = this.context.store.getState().session.fetching.user,
			nameSet = !!user.first && !!user.last;
		
		return (

			<h3 id="name-field" className={"mtop0 mbot20 " + (nameSet ? 'text-dark-gray' : 'text-dark-gray')}>
				{ editing_fields
					? <TextLength defaultValue={nameSet ? user.first + ' ' + user.last : ''} 
								onChange={updateName} 
								placeholder="Five to Nine Club Member"
								maxLength="30" 
								className="form-control" />
					: (nameSet ? user.first + ' ' + user.last : 'Five to Nine Club Member')
				}
			</h3>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Header/components/Name.jsx